import { render } from "./CollectionOrdersValidationConfigurations.html?vue&type=template&id=94508b54&scoped=true"
import script from "./CollectionOrdersValidationConfigurations.js?vue&type=script&lang=js"
export * from "./CollectionOrdersValidationConfigurations.js?vue&type=script&lang=js"

import "./CollectionOrdersValidationConfigurations.css?vue&type=style&index=0&id=94508b54&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94508b54"]])

export default __exports__